<template>

  <div class="container-lg  mt-4">
    <div class="row">
      <div class="col-lg-3">

        <category-list
            :in18="in18"
            :root_categories="root_categories"
        /><!-- /.categories -->

      </div><!-- /.col -->
      <div class="col-lg-9">

        <gallery
            :gallery_banners="gallery_banners"
        /><!-- /.offers-slider" -->

        <benefits
            :benefit_banners="benefit_banners"
        /><!-- /.offers-slider" -->

        <popular-slider
            :featured_categories="featured_categories"
            :in18="in18"
            :type="'popular'"
        />
      </div><!-- /.col -->
    </div><!-- /.row -->
  </div><!-- /.container -->

  <!-- Extra Section -->
  <product-extras
      :product_banner_one="product_banner_one"
      :product_banner_three="product_banner_three"
      :product_banner_two="product_banner_two"
  />

  <!-- Jaunākās preces -->
  <auto-slider :in18="in18" :type="'new'"></auto-slider>
  <!-- /.section -->

  <!-- Akcijas un atlaides -->
  <auto-slider v-if="!is_verified_b2b_client" :in18="in18" :type="'discount'"/>
  <!-- /.section -->

  <!-- Blog -->
  <blog-articles
      :blog_articles="blog_articles"
      :blog_link="blog_link"
      :in18="in18"
  /><!-- /.section -->

  <!-- Ražotāji -->
  <manufacturers
      :in18="in18"
      :manufacturers="manufacturers"
      :manufacturers_link="manufacturers_link"
  /><!-- /.section -->

</template>

<script>

import ProductExtras from "../components/home/ProductExtras.vue"
import Gallery from "../components/banner/Gallery.vue"
import Benefits from "../components/banner/Benefits.vue"
import BlogArticles from "../components/home/BlogArticles.vue"
import InfoBlock from "../components/home/InfoBlock.vue"
import Manufacturers from "../components/home/Manufacturers.vue"
import PopularSlider from "../components/sliders/PopularSlider.vue"
import AutoSlider from "../components/sliders/AutoSlider.vue"

export default {
  name:       "Home",
  components: {
    ProductExtras,
    Gallery,
    Benefits,
    BlogArticles,
    InfoBlock,
    Manufacturers,
    PopularSlider,
    AutoSlider,
  },
  props:      [
    'in18',
    'root_categories',
    'gallery_banners',
    'benefit_banners',
    'extra_banners',
    'product_banner_one',
    'product_banner_two',
    'product_banner_three',
    'blog_articles',
    'blog_link',
    'manufacturers',
    'manufacturers_link',
    'featured_categories',
    'is_verified_b2b_client',
  ],
}
</script>
